import { heroStats, siteName } from "@/mocks/site";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20stylized%20illustration%20of%20colorful%20comic%20book%20panels%20and%20pages%20floating%20in%20a%20warm%20orange%20and%20crimson%20artistic%20collage%20with%20speed%20lines%20and%20halftone%20dots%2C%20dramatic%20warm%20side%20lighting%2C%20abstract%20energetic%20manga%20aesthetic%2C%20dark%20graduated%20backdrop%20for%20text%20contrast%2C%20high%20detail&width=1920&height=1080&seq=dm-hero-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/60 to-background-950/80"></div>

      <div className="relative z-10 w-full px-4 md:px-10 py-28 md:py-32">
        <div className="max-w-4xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs md:text-sm px-4 py-1.5 backdrop-blur-sm">
            <i className="ri-flashlight-fill text-primary-300" aria-hidden="true"></i>
            韩漫 · 国漫 · 动漫 一站式免费观看入口
          </span>

          <h1 className="mt-6 font-heading text-background-50 text-4xl md:text-6xl leading-tight">
            {siteName}漫画大全
            <br />
            最新漫画资源，持续更新
          </h1>

          <p className="mt-5 text-background-50/85 text-base md:text-lg leading-relaxed max-w-2xl">
            聚合韩漫、动漫、国漫等丰富内容，提供免费在线观看与高清阅读体验。实时同步最新章节，
            无论你追热门榜单还是想挖冷门佳作，都能在这里快速找到资源入口，畅享不间断的漫画乐趣。
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="#library"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-background-50 text-sm md:text-base px-6 h-12 hover:bg-primary-600 transition-colors"
            >
              <i className="ri-search-eye-line" aria-hidden="true"></i>
              进入作品库
            </a>
            <a
              href="#ranking"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50/10 border border-background-50/30 text-background-50 text-sm md:text-base px-6 h-12 hover:bg-background-50/20 transition-colors"
            >
              <i className="ri-fire-line" aria-hidden="true"></i>
              查看今日榜单
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl">
            {heroStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-50/15 bg-background-50/10 backdrop-blur-sm px-4 py-4"
              >
                <dt className="text-background-50/70 text-xs md:text-sm">{stat.label}</dt>
                <dd className="mt-1 font-heading text-background-50 text-2xl md:text-3xl">
                  {stat.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}